'use client';

import { setCookie } from 'cookies-next';
import { graphqlClient } from 'lib/api';

export const tokenMaxAge = 14 * 24 * 3600000;
export const tokenPath = '/';

export const assignToken = (token: string) => {
  if (!token) return;

  graphqlClient.setHeader('authorization', `Bearer ${token}`);
  setCookie(process.env.NEXT_PUBLIC_USER_AUTH_TOKEN_NAME!, token, {
    maxAge: tokenMaxAge,
    path: tokenPath,
  });
};
